import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import type React from 'react';
import { RADIUS_ITEM } from 'styles/tokens';

const StyledStatusBadge = styled(Box)(() => ({
  borderRadius: RADIUS_ITEM,
  lineHeight: '1',
  height: '26px',
  fontWeight: 600,
  fontSize: '11px',
  letterSpacing: '0.03em',
  textTransform: 'uppercase',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 10px',
  whiteSpace: 'nowrap',
}));

interface Props {
  text: string;
  color: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  minWidth?: string;
  fontSize?: string;
}
const DebtStatusBadge: React.FC<Props> = ({ text, color, minWidth = '60px', fontSize, ...props }) => {
  return (
    <StyledStatusBadge
      {...props}
      color={color}
      sx={{
        bgcolor: `${color}.light`,
        color: `${color}.dark`,
        minWidth,
        ...(fontSize ? { fontSize } : {}),
      }}
    >
      {text}
    </StyledStatusBadge>
  );
};

export default DebtStatusBadge;
